/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NatureFxLightningBIcon24Solid = forwardRef('NatureFxLightningBIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M14.5 2.382c0-1.33-1.68-1.91-2.502-.864L3.984 11.737C3.264 12.655 3.918 14 5.086 14H9.5v7.617c0 1.33 1.68 1.91 2.502.864l8.014-10.218c.72-.918.066-2.264-1.102-2.264H14.5V2.382Z" })));
});
